import { Stack,Typography } from '@mui/material';
import { useContext,useEffect } from 'react';
import ChangeAlert from '../components/ChangeAlert/ChangeAlert';
import Footer from "../components/Footer/Footer";
import Header from '../components/Header/Header';
import ManagesTabs from '../components/Managements/ManagesTabs';
import Sidebar from '../components/Sidebar/Sidebar';
import { UserContext } from '../context/UserContext';
import { trackEventMatomoVisit } from '../helpers/matomo';
import { Container,SubContainer } from './Styles';

export default function Managements() {
  const { changed } = useContext(UserContext);

  useEffect(() => {
    trackEventMatomoVisit('Gestão de gerências');
  }, []);

  return (
    <Container>
      <Sidebar />
      <SubContainer>
        {changed && <ChangeAlert />}
        <Header />
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          sx={{ padding: `${window.innerWidth < 800 ? '20px 2% 100px 2%' : '20px 5% 100px 5%'}` }}
        >
          <Typography variant='h5'>Gestão de gerencias</Typography>
          <ManagesTabs />
        </Stack>
        <Footer />
      </SubContainer>
    </Container>
  );
}
